<template>
  <div class="content-box">
    <div class="element-wrapper pb-0">
      <div class="element-header">
        <div class="row">
          <div class="col-md-8 mr-auto">
            <h3 class>Faturas avulsas do Pedido #{{pedido.idPedidoVindi}}</h3>
          </div>
          <div class="col-auto">
            <b-button @click="voltar">Voltar</b-button>
          </div>
          <div class="col-auto">
            <b-button @click="openModalNovo">Novo</b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-end mb-2" v-if="pedido.formadePagamento === 'carne'">
      <div class="col-auto">
        <b-button @click="enviarCarnePorEmail(pedido.idPedidoVindi)">
          <i class="far fa-envelope"></i>
          Enviar Carnê por email
        </b-button>
      </div>
      <div class="col-auto">
        <b-button @click="enviarCarnePorWhatsapp(pedido.idPedidoVindi)">
          <i class="fab fa-whatsapp"></i>
          Enviar Carnê por Whatsapp
        </b-button>
      </div>
      <div class="col-auto" v-if="isAdministrador">
        <b-button @click="atualizarDadosFinanceiros(pedido)">
          <i class="fa fa-credit-card"></i>
          Atualizar Dados Financeiros
        </b-button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-card>
          <table class="table">
            <thead>
              <th>Forma de pagamento</th>
              <th>Produto</th>
              <th style="width: 10%">Valor Total</th>
              <th>Data de vencimento da cobrança</th>
              <th>Status Entrega Cartão</th>
              <th>Status</th>
              <th></th>
            </thead>
            <tbody v-if="empresa.plataformaPagamento === 'vindi'">
              <tr v-for="(fatura,i) in transacoes" :key="i">
                <td>{{getFormaPagamento(fatura)}}</td>
                <td>{{fatura.vindi.bill_items[0].product.name}}</td>
                <td>{{fatura.vlTotal | money}}</td>
                <td>{{formataData(getCharge(fatura.vindi.charges) ? getCharge(fatura.vindi.charges).due_at : '')}}</td>
                <td>{{fatura.statusImpressao}}</td>
                <td>{{traduzirStatusPagamento(fatura.vindi)}}</td>
                <td>
                  <b-button v-if="isEnviadoCorreio(fatura)" variant="light" @click="visualizar(fatura)">
                    <i class='fa fa-search'></i> Visualizar
                  </b-button>
                  <b-button-group v-else>
                    <b-dropdown variant="light" right split text="" @click="visualizar(fatura)">
                      <template slot="button-content">
                          <i class='fa fa-search'></i> Visualizar
                      </template>
                      <b-dropdown-item title="Exibir Boleto" target="_blank"
                        :href="getCharge(fatura.vindi.charges).print_url" v-if="getCharge(fatura.vindi.charges) && getCharge(fatura.vindi.charges).print_url">
                        <i class="fa fa-file-pdf"></i> Boleto
                      </b-dropdown-item>
                      <b-dropdown-item title="Enviar Boleto via Whatsapp" target="_blank"
                        :href="enviarBoletoWhatsapp(getCharge(fatura.charges).print_url)" v-if="getCharge(fatura.vindi.charges) && getCharge(fatura.charges).print_url">
                        <i class="fab fa-whatsapp"></i> Enviar Boleto via Whatsapp
                      </b-dropdown-item>
                      <b-dropdown-item @click="enviarBoletoPorEmail(fatura)"
                        v-if="getCharge(fatura.vindi.charges) && getCharge(fatura.charges).print_url && !isVencida(fatura)"
                        title="Enviar boleto por email">
                        <i class="fa fa-folder"></i> Enviar Boleto por email
                      </b-dropdown-item>
                      <b-dropdown-item v-if="isPaid(fatura.vindi) && isTaxaEmissao(fatura) && !isEnviadoGrafica(fatura)" @click="enviarGrafica(fatura)">
                        <i class="fa fa-folder"></i> Enviar para Gráfica
                      </b-dropdown-item>
                      <b-dropdown-item v-if="isPaid(fatura.vindi) && isTaxaEmissao(fatura) && isEnviadoGrafica(fatura) && !isEnviadoCorreio(fatura)" @click="enviarCorreio(fatura)">
                        <i class="fa fa-folder"></i> Enviar para correio
                      </b-dropdown-item>
                      <b-dropdown-item @click="showModalAtualizarDataVencimento(fatura.vindi)" v-if="!isPaid(fatura.vindi)" title="Atualizar vencimento">
                        <i class="fa fa-calendar"></i> Atualizar vencimento
                      </b-dropdown-item>
                    </b-dropdown>
                  </b-button-group>
                </td>
              </tr>
            </tbody>

            <tbody v-if="empresa.plataformaPagamento === 'Pagar.me'">
              <tr v-for="(fatura,i) in transacoes" :key="i">
                <td>{{getTextoFormaPagamento(fatura)}}</td>
                <td>{{fatura.pagarme.items[0].title}}</td>
                <td>{{fatura.vlTotal | money}}</td>
                <td>{{formataData(fatura.pagarme.date_created)}}</td>
                <td>{{fatura.statusImpressao}}</td>
                <td>{{traduzirStatusPagamento(fatura.pagarme)}}</td>
                <td>
                  <b-button v-if="isEnviadoCorreio(fatura)" variant="light" @click="visualizar(fatura)">
                    <i class='fa fa-search'></i> Visualizar
                  </b-button>
                  <b-button-group v-else>
                    <b-dropdown variant="light" right split text="" @click="visualizar(fatura)">
                      <template slot="button-content">
                        <i class='fa fa-search'></i> Visualizar
                      </template>
                    </b-dropdown>
                  </b-button-group>
                </td>
              </tr>
            </tbody>

          </table>
        </b-card>
      </div>
    </div>

      <transacoesAvulsaModal v-if="pedido && pedido._id" :pedido="pedido"></transacoesAvulsaModal>
      <viewTransacoesAvulsaModal :pedido="pedido" :transacao="transacao"></viewTransacoesAvulsaModal>
      <alterarFormaPagamentoModal :pedido="pedido" :fatura="fatura"></alterarFormaPagamentoModal>


  </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import transacoesAvulsaModal from '@/components/transacoesAvulsa/TransacoesAvulsaModal'
import viewTransacoesAvulsaModal from '@/components/transacoesAvulsa/ViewTransacoesAvulsaModal'
import alterarFormaPagamentoModal from '@/components/transacoesAvulsa/AlterarFormaPagamentoModal'



export default {
    async created(){
        const id = this.$route.query.id;

        const responsePedido = await axios.get(`/api/saude/${id}`);
        this.pedido = responsePedido.data;

        const responseTransacoes = await axios.get(`/api/saude/faturaAvulsa?idPedido=${this.pedido._id}`);
        this.transacoes = responseTransacoes.data;
    },
    data() {
        return {
            pedido: {},
            transacoes: [],
            fatura: {},
            transacao: {}
        }
    },
    computed: {
      empresa() {
        return this.$store.getters.empresa || {};
      },
      isAdministrador() {
        return this.$store.getters.isAdministrador;
      }
    },
    components: {
      transacoesAvulsaModal,
      viewTransacoesAvulsaModal,
      alterarFormaPagamentoModal
    },
    mounted() {
      this.$root.$on('bv::modal::hide', async (bvEvent, modalId) => {
        if (modalId === 'modalTransacaoAvulsaNovo' || modalId === 'modalAtualizarDataVencimento') {
          const responseTransacoes = await axios.get(`/api/saude/faturaAvulsa?idPedido=${this.pedido._id}`);
          this.transacoes = responseTransacoes.data;
        }
      });
    },
    methods: {
      voltar(){
        window.history.back();
      },
      openModalNovo() {
        this.$bvModal.show('modalTransacaoAvulsaNovo');
      },
      formataData(value) {
        if (!value) return '';
        return moment(value).format("DD/MM/YYYY");
      },
      isVencida(fatura) {
        let dataVencimento = new Date(this.getCharge(fatura.charges).due_at);
        return moment().isSameOrAfter(dataVencimento);
      },
      isPaid(fatura) {
         let statusVindi = (this.getCharge(fatura.charges) ? this.getCharge(fatura.charges).last_transaction.status : fatura.status) || fatura.status;
        return statusVindi === 'paid' || statusVindi === 'success';
      },
      getCharge(charges) {
        if (!charges) {
          return {}
        }
        if (charges.length === 1) {
          return charges[0];
        }

        return charges.find(charge => charge.status === 'pending' || charge.status === 'paid' || charge.status === 'canceled')
      },
      traduzirStatusPagamento(fatura) {
        let statusVindi = fatura.status;
        switch (statusVindi) {
            case 'processing':
              return 'Processando pagamento';
            case 'failure':
              return 'Falha ao processar pagamento';
            case 'rejected':
              return 'Pagamento rejeitado';
            case 'success':
              return 'Pagamento Efetuado';
            case 'paid':
              return 'Pagamento Efetuado';
            case 'waiting':
              if (this.isVencida(fatura)) {
                return 'Vencida'
              }
              return 'Aguardando pagamento';
            case 'canceled':
              return 'Cancelado';
            default:
              return statusVindi;
          }
      },
      showModalAtualizarDataVencimento(fatura) {
        this.fatura = fatura;
        this.$nextTick(() => this.$bvModal.show('modalAtualizarDataVencimento'));
      },
      visualizar(transacao) {
        this.transacao = transacao;
        this.$nextTick(() => this.$bvModal.show('modalViewTransacaoAvulsa'));
      },
      isTaxaEmissao(transacao) {
          return transacao && transacao.vindi.bill_items[0].product.code === 'taxaEmissaoCartao';
      },
      isEnviadoGrafica(transacao) {
        return transacao.statusImpressao === 'ENVIADO PARA GRAFICA';
      },
      isEnviadoCorreio(transacao) {
        return transacao.statusImpressao === 'ENVIADO PARA CORREIOS';
      },
      async enviarGrafica(transacao) {
        try {
          const result = await this.$bvModal.msgBoxConfirm('Deseja relmente enviar a solicitação para gráfica?');
          if (result) {
            transacao.statusImpressao = 'ENVIADO PARA GRAFICA';
            await axios.put(`/api/faturaAvulsa/${transacao._id}`, transacao);

            const responseTransacoes = await axios.get(`/api/saude/faturaAvulsa?idPedido=${this.pedido._id}`);
            this.transacoes = responseTransacoes.data;
          }
        } catch (error) {
          throw error;
        }
      },
      async enviarCorreio(transacao) {
        try {
          transacao.statusImpressao = 'ENVIADO PARA CORREIOS';
          await axios.put(`/api/transacaoAvulsa/${transacao._id}`, transacao);

          const responseTransacoes = await axios.get(`/api/saude/faturaAvulsa?idPedido=${this.pedido._id}`);
          this.transacoes = responseTransacoes.data;
        } catch (error) {
          throw error;
        }
      },
      getTextoFormaPagamento(fatura) {
        switch (fatura.formaPagamento) {
          case 'credit_card':
            return 'Cartão Credito';
          default:
            return "Boleto";
        }
      },

      async atualizarDadosFinanceiros() {
        try {
          this.$store.dispatch('setLoading', true);
          await axios.post(`/api/saude/faturaAvulsa/updateInfo?pedido=${this.pedido._id}`);

          const responseTransacoes = await axios.get(`/api/saude/faturaAvulsa?idPedido=${this.pedido._id}`);
          this.transacoes = responseTransacoes.data;
        } catch (error) {
          throw error;
        } finally {
          this.$store.dispatch('setLoading', false);
        }
      },
      getFormaPagamento(fatura) {
          let charge = this.getCharge(fatura.vindi.charges)
          if (charge != null && charge.id) {
              return charge.payment_method.public_name
          }
          return ""
      }
    }
}
</script>
